module.exports = __webpack_public_path__ + "static/media/arrow-up-product.46620d51.png";